import { IRegisterManagerInjectable } from '@src/slide/application/service/register-manager/inject/register-manager.interface';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export class RegisterManagerInjectable implements IRegisterManagerInjectable {
    // your implementations here
    public get shouldListenSocketChange() {
        // 非本地编辑&非预览态 才增加netChange监听
        return !ENV.IS_LOCAL_EDIT && !isPreview();
    }

    // 是否监听 socket commit upload 事件
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    public get shouldListenSocketCommitUpload() {
        return false;
    }
}
